// import { environment } from '../../../../environments/environment';
import type { Listing } from '@thevillages/schemas';

import type { ListingsService } from '../listings';

import { Environment } from '../../../../environments/environment';

export function Areas(this: ListingsService, listing: Listing, currentValue: boolean): boolean {
  // If no value is set, do not affect the filter.
  if (!this.filteringService.areas().length) {
    // if the community is not villages, ignore the family neighborhoods area filter since it does not apply.
    if (Environment.community !== 'villages') {
      return currentValue;
    }

    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- This condition is necessary until we update the logic to fit the new types package.
    if (listing.area?.id === 'family-neighborhoods') {
      return false;
    }

    return currentValue;
  }

  // If the listing does not have a value, exclude it from results.
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- This condition is necessary until we update the logic to fit the new types package.
  if (!listing.area?.id) {
    return false;
  }

  // Determine if the listing matches the filter.
  if (!this.filteringService.areas().includes(listing.area.id)) {
    return false;
  }

  // If the listing does not match the filter, do not affect the filter.
  return currentValue;
}
